module.exports = __webpack_public_path__ + "img/mitrex_logo_white_sm.e8aad383.png";